import Dropdown from 'bootstrap/js/dist/dropdown';
import Tab from 'bootstrap/js/dist/tab';
import Collapse from 'bootstrap/js/dist/collapse';

(function ($) {
    $(function () {
      
      
      function updateImageTop() {
        var scrollTop = $(window).scrollTop();
    
        $('.img-wrap-fixed').each(function() {
          var $wrap = $(this);
          var $img = $wrap.find('.img-ab');
    
          var wrapOffsetTop = $wrap.offset().top;
    
          // Calculate how far the container is from the top of the page
          var distanceFromTop = wrapOffsetTop - scrollTop;
    
          // Set that as the image's top value
          $img.css('top', -distanceFromTop + 'px');
        });
      }
    
      $(window).on('scroll resize', updateImageTop);
      $(document).ready(updateImageTop);
      
      // paralax
      function applyParallax() {
        $('.img-para').each(function () {
            var scrollTop = $(window).scrollTop();
            var offsetTop = $(this).offset().top;
            var height = $(this).outerHeight();
            var windowHeight = $(window).height();

            if (offsetTop + height > scrollTop && offsetTop < scrollTop + windowHeight) {
                var speed = 0.1;
                var translateY = (offsetTop - scrollTop) * speed;
                $(this).find('.img-ab').css('transform', 'translateY(' + translateY + 'px)');
            }
        });
    }

    // Apply immediately and on scroll
    applyParallax();
    $(window).on('scroll', applyParallax);
      
      // menu
      function bindMenuTrigger() {
        const $trigger = $('.menu-target');
        const isMobile = window.innerWidth < 992;
      
        // Clear all previous events
        $trigger.off('mouseenter click');
        $('.header .menu-item, .header .btn-wrap, .header .search-wrap, .services-menu .inner-wrap').off('mouseenter mouseleave');
      
        if (isMobile) {
          // Mobile click
          $trigger.on('click', function (e) {
            e.preventDefault();
            $('.services-menu').toggleClass('active');
            $('.header').toggleClass('menu-active');
            $(this).toggleClass('active');
          });
        } else {
          // Desktop hover
          $trigger.on('mouseenter', function () {
            $('.services-menu').addClass('active');
            $('.header').addClass('menu-active');
            $trigger.addClass('active');
          });
      

          // Remove when hovering another menu-item, or .btn-wrap, .search-wrap
          $('.header .menu-item').on('mouseenter', function () {
            if (!$(this).is('.menu-target')) {
              $('.services-menu').removeClass('active');
              $('.header').removeClass('menu-active');
              $trigger.removeClass('active');
            }
          });
      
          $('.header .btn-wrap, .header .search-wrap').on('mouseenter', function () {
            $('.services-menu').removeClass('active');
            $('.header').removeClass('menu-active');
            $trigger.removeClass('active');
          });
      
          // Also remove when mouse leaves the inner-wrap of the dropdown
          $('.services-menu .inner-wrap').on('mouseleave', function () {
            $('.services-menu').removeClass('active');
            $('.header').removeClass('menu-active');
            $trigger.removeClass('active');
          });
        }
      }
      
      $(document).ready(function () {
        bindMenuTrigger();
      });
      
      $(window).on('resize', function () {
        bindMenuTrigger();
      });
      
      
      $('.mobile-menu .menu-target').on('click', function(e){
        e.preventDefault();
        $('.services-menu').toggleClass('active');
      });
      
      $('.hamburger').click(function(e){
        e.preventDefault();
        $(this).toggleClass('is-active');
        $('.header').toggleClass('menu-active');
        $('.mobile-menu').toggleClass('active');
        $('.services-menu').removeClass('active');
      });
      
      $('.back-menu').on('click', function(){
        $('.services-menu').removeClass('active');
      });
      
      // post progress
      
      const $progress = $('.progress-bar');
      const $content = $('.post-content');
    
      function updateProgressBar() {
        const windowHeight = $(window).height();
        const scrollTop = $(window).scrollTop();
    
        const contentTop = $content.offset().top;
        const contentHeight = $content.outerHeight();
        const contentBottom = contentTop + contentHeight;
    
        const visibleStart = Math.max(contentTop, scrollTop);
        const visibleEnd = Math.min(contentBottom, scrollTop + windowHeight);
    
        const visibleLength = visibleEnd - visibleStart;
        const totalScrollable = contentBottom - windowHeight - contentTop;
    
        if (scrollTop + windowHeight < contentTop) {
          // Not entered yet
          $progress.css('width', '0%');
        } else if (scrollTop > contentBottom) {
          // Passed it completely
          $progress.css('width', '100%');
        } else {
          // In progress
          const progress = ((scrollTop + windowHeight - contentTop) / (contentBottom - contentTop)) * 100;
          const clamped = Math.max(0, Math.min(progress, 100));
          $progress.css('width', clamped + '%');
        }
      }
    
      if($progress.length) {
        $(window).on('scroll resize load', updateProgressBar);
      }
      
      // accordion
    $('.acc-item .acc-title').on('click', function(e){
        e.preventDefault();
        if($(this).parent().hasClass('active')) {
          $(this).parent().removeClass('active');
          $(this).next().slideUp(300);
        } else {
          $('.acc-item .acc-content').slideUp(300);
          $('.acc-item').removeClass('active');
          $(this).parent().addClass('active');
          $(this).next().slideDown(300);
        }
      });
      
      // team accord
      $('.toggle-text').on('click', function () {
        const $btn = $(this);
        const $card = $btn.closest('.team-card-detail__card');
        const $fullText = $card.find('.full-text');
      
        $fullText.slideToggle(300);
        $btn.toggleClass('active');
      });
      
      // anchor actives
      const $links = $('.anchor-nav-item');
  const sections = $links.map(function () {
    const id = $(this).attr('href');
    const $section = $(id);
    if ($section.length) return $section;
  });

  function onScroll() {
    const scrollPos = $(window).scrollTop() + 100; // adjust for fixed header if needed
    let current;

    sections.each(function () {
      const top = $(this).offset().top;
      if (scrollPos >= top) {
        current = this;
      }
    });

    $links.removeClass('active');
    if (current) {
      const id = $(current).attr('id');
      $links.filter('[href="#' + id + '"]').addClass('active');
    }
  }

  $(window).on('scroll resize load', onScroll);
      
      $('a[href*="#"]')
          // Remove links that don't actually link to anything
          .not('[href="#"]')
          .not('[href="#0"]')
          .click(function(event) {
            // On-page links
            if (
              location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
              &&
              location.hostname == this.hostname
            ) {
              // Figure out element to scroll to
              var target = $(this.hash);
              target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
              // Does a scroll target exist?
              if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
        $('html, body').animate(
          {
            scrollTop: target.offset().top - 50
          },
          600
          );
      }
    }
  });

        $('ul.navbar-nav li.dropdown').hover(function() {
            $(this).find('.dropdown-menu').stop(true, true).delay(100).fadeIn(250);
        }, function() {
            $(this).find('.dropdown-menu').stop(true, true).delay(100).fadeOut(250);
        });
        
        if($('.hero').length) {
            $('.header').addClass('header-alt');
        }
          
          
        //   header scroll
        
        var didScroll;
        var lastScrollTop = 0;
        var delta = 5;
        var navbarHeight = $('.header').outerHeight();

        $(window).on('scroll', function () {
        didScroll = true;
        });

        setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
        }, 250);

        function hasScrolled() {
        var st = $(window).scrollTop();

        // Back to top — reset
        if (st <= 0) {
            $('.header').removeClass('sticky nav-up');
            $('.anchor-nav').removeClass('nav-down');
            $('.progress').removeClass('sticky nav-up');
            $('body').removeClass('has-sticky-space');
            lastScrollTop = 0;
            return;
        }

        // Add sticky once past navbar
        if (!$('.header').hasClass('sticky') && st > navbarHeight) {
            $('.header').addClass('sticky');
            $('.progress').addClass('sticky');
            $('body').addClass('has-sticky-space');
        }

        // Ignore small scroll
        if (Math.abs(lastScrollTop - st) <= delta) return;

        if (st > lastScrollTop && st > navbarHeight) {
            // Scrolling down
            $('.header').addClass('nav-up');
            $('.anchor-nav').removeClass('nav-down');
            $('.progress').addClass('nav-up');
        } else {
            // Scrolling up
            $('.header').removeClass('nav-up');
            $('.anchor-nav').addClass('nav-down');
            $('.progress').removeClass('nav-up');
        }

        lastScrollTop = st;
        }
        
        
        function animateZoom($el, toScale, duration, zoomRAFStore) {
          cancelAnimationFrame(zoomRAFStore.current);
          const node = $el.get(0);
          if (!node) return;
        
          const computedStyle = window.getComputedStyle(node);
          const matrix = new WebKitCSSMatrix(computedStyle.transform);
          const fromScale = matrix.a || 1;
        
          const startTime = performance.now();
        
          function step(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const scale = fromScale + (toScale - fromScale) * progress;
        
            node.style.transform = `scale(${scale})`;
        
            if (progress < 1) {
              zoomRAFStore.current = requestAnimationFrame(step);
            }
          }
        
          zoomRAFStore.current = requestAnimationFrame(step);
        }
        
        function startZoom($slide, zoomRAFStore) {
          const $target = $slide.find('.img-wrap, .vid-wrap');
          animateZoom($target, 1.12, 8000, zoomRAFStore); // unified zoom duration
        }
        
        function gentlyResetZoom($slide) {
          const $target = $slide.find('.img-wrap, .vid-wrap');
          setTimeout(() => {
            $target.css('transform', 'scale(1)');
          }, 1000); // matches fade speed
        }
          
          // === HERO SLIDER ===
          $('.hero-slider').each(function () {
            const $slider = $(this);
            const zoomRAFStore = { current: null };
          
            $slider.slick({
              infinite: true,
              fade: true,
              speed: 1000,
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
              arrows: false,
              autoplay: true,
              autoplaySpeed: 5000,
              pauseOnHover: false,
              pauseOnFocus: false,
            });
          
            $slider.on('beforeChange', function (event, slick, currentSlide) {
              const $leavingSlide = $(slick.$slides.get(currentSlide));
              gentlyResetZoom($leavingSlide);
            });
          
            $slider.on('afterChange', function (event, slick, currentSlide) {
              const $activeSlide = $(slick.$slides.get(currentSlide));
              startZoom($activeSlide, zoomRAFStore);
            });
          
            const $initial = $slider.find('.slick-slide.slick-current');
            startZoom($initial, zoomRAFStore);
          });
          
          // === IMAGE SLIDER ===
          $('.image-slider').each(function () {
            const $slider = $(this);
            const zoomRAFStore = { current: null };
          
            $slider.slick({
              infinite: true,
              // fade: true,
              speed: 1000,
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
              arrows: true,
              appendArrows: $slider.closest('section').find('.slick-arrows-wrap'),
              autoplay: true,
              autoplaySpeed: 5000,
              pauseOnHover: false,
              pauseOnFocus: false,
            });
          
            $slider.on('beforeChange', function (event, slick, currentSlide) {
              const $leavingSlide = $(slick.$slides.get(currentSlide));
              gentlyResetZoom($leavingSlide);
            });
          
            $slider.on('afterChange', function (event, slick, currentSlide) {
              const $activeSlide = $(slick.$slides.get(currentSlide));
              startZoom($activeSlide, zoomRAFStore);
            });
          
            const $initial = $slider.find('.slick-slide.slick-current');
            startZoom($initial, zoomRAFStore);
          });
          
        
        
        $('.footer__nav .menu > li > a').matchHeight();
        
        $('.panel-item .wrapper').matchHeight();
        
        $('.team-item h3').matchHeight();
        $('.team-item .content-wrap').matchHeight();


        function animateCountTarget($element) {
            if ($element.hasClass('animated')) return;

            const originalText = $element.data('original-text') || $element.text().trim();

            // Capture prefix, number, suffix
            const match = originalText.match(/^([^0-9\-]*)(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?(.*)$/);
            if (!match) return;

            const prefix = match[1] || "";
            const numberWithFormat = match[2] + (match[3] || "");
            const suffix = match[4] || "";

            const numberPlain = numberWithFormat.replace(/,/g, '');
            const targetNumber = parseFloat(numberPlain);

            const duration = 2500;
            const fps = 60;
            const steps = duration / (1000 / fps);
            let currentStep = 0;
            const numberStep = targetNumber / steps;

            $element.addClass('animated');

            const interval = setInterval(() => {
                currentStep++;
                const currentNumber = Math.min(Math.round(numberStep * currentStep), targetNumber);
                const formattedNumber = currentNumber.toLocaleString();

                // Reassemble with prefix and suffix
                $element.text(prefix + formattedNumber + suffix);

                if (currentStep >= steps) {
                    clearInterval(interval);
                    $element.text(prefix + targetNumber.toLocaleString() + suffix);
                }
            }, 1000 / fps);
        }
      
      function checkCountWrapperInView() {
          const $wrappers = $('.count-wrapper');
      
          $wrappers.each(function () {
              const $wrapper = $(this);
              const windowTop = $(window).scrollTop();
              const windowBottom = windowTop + $(window).height();
              const wrapperTop = $wrapper.offset().top;
              const wrapperBottom = wrapperTop + $wrapper.outerHeight();
      
              if (windowBottom > wrapperTop + 100 && windowTop < wrapperBottom) {
                  // In view
                  if (!$wrapper.hasClass('animated')) {
                      $wrapper.addClass('animated');
                      $wrapper.find('.count-target').each(function () {
                          const $el = $(this);
                          if (!$el.data('original-text')) {
                              $el.data('original-text', $el.text().trim());
                          }
                          animateCountTarget($el);
                      });
                  }
              } else {
                  // Out of view
                  $wrapper.removeClass('animated');
                  $wrapper.find('.count-target').removeClass('animated').each(function () {
                      const $el = $(this);
                      if ($el.data('original-text')) {
                          $el.text($el.data('original-text'));
                      }
                  });
              }
          });
      }
      
      $(window).on('scroll resize load', function () {
          checkCountWrapperInView();
      });
      
        
        
        AOS.init({
          duration: 800,
        });
        
        onElementHeightChange(document.body, function(){
          AOS.refresh();
        });
        
        // elements change heights aos

      function onElementHeightChange(elm, callback) {
        var lastHeight = elm.clientHeight
        var newHeight;
        (function run() {
          newHeight = elm.clientHeight;      
          if (lastHeight !== newHeight) callback();
            lastHeight = newHeight;
        
          if (elm.onElementHeightChangeTimer) {
            clearTimeout(elm.onElementHeightChangeTimer); 
          }
        
          elm.onElementHeightChangeTimer = setTimeout(run, 200);
      })();


      }
      
      
      let currentPage = window.postData.currentPage + 1;
let maxPages = parseInt(window.postData.maxPages);
let loading = false;
const buffer = 200;
const $container = $('.post-listings-list');

function isLastPostAboveBottom($el, buffer = 200) {
  if (!$el.length) return false;
  const rect = $el[0].getBoundingClientRect();
  return rect.bottom <= window.innerHeight - buffer;
}

function loadMorePosts() {
  if (loading || currentPage > maxPages) return;

  loading = true;
  $('#loader').show();

  $.ajax({
    url: window.postData.ajaxUrl,
    type: 'POST',
    data: {
      action: 'load_more_posts',
      paged: currentPage,
      nonce: window.postData.nonce,
      location: window.postData.location,
      service: window.postData.service,
      orderby: window.postData.orderby,
    },
    success: function (res) {
      if ($.trim(res)) {
        const $newItems = $(res).css({ opacity: 0 });
        $container.append($newItems);

        // Wait for images before fade in
        const $imgs = $newItems.find('img');
        let loaded = 0;
        const total = $imgs.length;

        if (total === 0) {
          $newItems.animate({ opacity: 1 }, 300);
        } else {
          $imgs.on('load error', function () {
            loaded++;
            if (loaded === total) {
              $newItems.animate({ opacity: 1 }, 300);
            }
          }).each(function () {
            if (this.complete) $(this).trigger('load');
          });
        }

        currentPage++;
      } else {
        $(window).off('scroll.infinite');
      }
    },
    complete: function () {
      loading = false;
      $('#loader').hide();
    }
  });
}

$(window).on('scroll.infinite resize', function () {
  const $last = $container.children().last();
  if ($last.length && isLastPostAboveBottom($last, buffer)) {
    loadMorePosts();
  }
});


    });
})(window.jQuery)

